import {  useEffect } from "react";
import { useHistory, useParams } from "react-router";
import en from '../../../../lang/en-us';
import SuccessScreen from "../../makeNct/SuccessScreen";
import { CommercialRootPath } from "../routeConfig";
import MfSuccess from "./mf-success";

const { dashboard } = en;

const MfProspectSuccess: React.FunctionComponent<any> = (props) => {
    const history = useHistory();
    const { id } = useParams<{ id: string }>();

    useEffect(() => {
        if (!id) {
            history.push('/');
        }
    }, []);

    return (
        <div className="curved-bg">
            <SuccessScreen
                heading={dashboard.UpdateNominee.Success.back}
                backLink="nct"
                info1={dashboard.UpdateNominee.Success.subHeadingInfo1}
                infospan1="Reinvest to Payment"
                info2={dashboard.UpdateNominee.Success.subHeadingInfo2}
                infospan2={`${id}`}
                info3={dashboard.UpdateNominee.Success.subHeadingInfo3}
                list={[]}
                handleClick={() => props.history.push('/portal/track?tab=2')}
                backNavigation={() => props.history.push(`${CommercialRootPath}`)}
            />
        </div>
    );
};
export default MfProspectSuccess;
